import type { ReactNode } from "react"
import { Link } from "@tanstack/react-router"
import { useGetCmsData, useUserPermissions } from "@/lib/hooks"
import { useTempStore } from "@/lib/store"

// Wrap the authenticated start routes, rather than checking inside the
// recording component: denied/loading users must never mount its camera,
// microphone or upload effects. Public demo routes use the unwrapped pages.
export function PresentationPracticeAccess({
  children,
}: {
  children: ReactNode
}) {
  const user = useTempStore((state) => state.user)
  const { data: cmsData, isError } = useGetCmsData()
  const { enablePresentations } = useUserPermissions()

  if (isError) {
    return (
      <p role="alert" className="text-copy-mid">
        We couldn’t check presentation access. Please refresh and try again.
      </p>
    )
  } else if (!user || !cmsData) {
    return (
      <p role="status" className="text-copy-mid">
        Checking presentation access…
      </p>
    )
  } else if (user.archived || !enablePresentations) {
    return (
      <div className="rounded-lg border bg-card p-6 shadow-sm">
        <p className="text-copy-mid">
          Presentation practice is not available for your account.
        </p>
        <Link
          to="/"
          className="mt-3 inline-block text-sm font-medium text-brand-accent"
        >
          Back to home
        </Link>
      </div>
    )
  } else {
    return children
  }
}
